'use strict';

module.exports = {
    name: 'app',
    components: {
        form: require('../form/form.vue')
    }
};
